module.exports = __webpack_public_path__ + "media/images/static/our_work/01_hearing-722cb5b20de83faffdebb57d82563833.png";